module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_a-function.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_a-function.js
// module chunks = 168707334958949